
import  {  useState,useContext } from "react"
import { Typography } from '@mui/material';

import BasicTable from "./BasicReactTable";
import FormHOC from "./FormHOC"
import { errorContext } from '../Components/ErrorDisplay'

export default function ParentComponent(props)
{
    const[isTableDisplay,setIsTableDisplay] = useState(true);
    const[selectedRow,setSelectedRow] = useState(null);
    const {setErrorMessage} = useContext(errorContext);
    const setFormShownFlag = typeof props.setFormShownFlag === 'function'
      ? props.setFormShownFlag
      : () => {};
    const setSelectedRowProp = typeof props.setSelectedRow === 'function'
      ? props.setSelectedRow
      : () => {};

    // create form component only if a form constructor was provided
    const FormComponent = props.form ? FormHOC(props.form) : null;
      
    function handleSetSelectedRow(row) {
      setSelectedRow(row);
    }
    function handleSubmit(data,isAddOperation,isCancelOperation)
    {
        const showTable = () => {
            setSelectedRow(null);
            setIsTableDisplay(true);
            setFormShownFlag(false);
        };
        console.log("SUBMIT-"+JSON.stringify(data));
        // Cancel: return to the table immediately (no server call to wait on).
        if (isCancelOperation) {
            showTable();
            props.handleFormSubmitFunc(data,isAddOperation,isCancelOperation);
            return;
        }
        const result = props.handleFormSubmitFunc(data,isAddOperation,isCancelOperation);
        // Opt-in: if the page returns a Promise, wait for the server before leaving
        // the form - show the table only on success, and stay on the form on failure
        // so the user's values are preserved and they can fix and resubmit. Pages
        // that return nothing keep the previous behaviour (switch immediately).
        if (result && typeof result.then === 'function') {
            result.then(showTable).catch(() => { /* stay on the form */ });
        } else {
            showTable();
        }
    }
    function addFunc()
    {
      if(!props.form) return; // nothing to show
      setErrorMessage(null)
      setSelectedRow(null);
      setSelectedRowProp(null);
      setIsTableDisplay(false);
      console.log(isTableDisplay)
      setFormShownFlag(true);
      //props.addFunc();
    }
    
    function editFunc(row)
    {
      if(!props.form) return;
      setErrorMessage(null)
      setSelectedRow(row);
      setIsTableDisplay(false);
      setFormShownFlag(true);
    }
   
    // function deleteFunc(row)
    // {
    //   setSelectedRow(row);
    //   props.deleteFunc(row);
    //   setIsTableDisplay(true);
    //   props.setFormShownFlag(false);
    // }
    
        // if(isTableDisplay===true)
        //     return (<BasicTable
        //         onAddClick = {addFunc}
        //         onEditClick = {editFunc}
        //         onDeleteClick = {props.deleteFunc}
        //         rows={props.data}
        //         columns={props.columns}
        //         setSelectedRow={props.setSelectedRow}
        //         setParentSelectedRow={handleSetSelectedRow}
        //             />);
        // else
        //       return(<div><FormComponent 
        //         ps={[
        //           {handleSubmit:handleSubmit,
        //           selectedRow:selectedRow}]
        //           } >
        //           </FormComponent></div>)
        // always show table when there's no form or when table flag is true
        if(isTableDisplay || !props.form) {
            return (<BasicTable
                onAddClick = {addFunc}
                onEditClick = {editFunc}
                onDeleteClick = {props.deleteFunc}
                rows={props.data}
                columns={props.columns}
                setSelectedRow={setSelectedRowProp}
                setParentSelectedRow={handleSetSelectedRow}
                alreadySelectedOwnRow={props.alreadySelectedOwnRow}
                isAddDisabled={props.isAddDisabled}
                isEditDisabled={props.isEditDisabled}
                isDeleteDisabled={props.isDeleteDisabled}
                    />);
        }

        // otherwise render the form component
        return FormComponent ? (
          <div>
            {!props.hideFormTitle && (
              <Typography variant="h5" style={{ textAlign: 'left', marginBottom: '12px' }}>
                {(selectedRow ? 'Edit ' : 'Add ') + (props.formTitle || 'Form')}
              </Typography>
            )}
            <FormComponent
              ps={[
                {handleSubmit:handleSubmit,
                selectedRow:selectedRow,
                IssuingPartnerRow:props.selectedIssuingPartnerRow,
                BrandRow:props.selectedBrandRow,
                RedemptionPartnerRow:props.selectedRedemptionPartnerRow,
                RedemptionPartnerList:props.redemptionPartnerList,
                onRedemptionPartnerChange:props.onRedemptionPartnerChange,
                LocationRow:props.selectedLocationRow,
                progress:props.progress,
                mode:props.mode}]
                }
            >
            </FormComponent>
          </div>
        ) : null;
        
        

}
